"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkoutTimestamp = checkoutTimestamp;
exports.getBaseInfo = getBaseInfo;
exports.getCountryTimezone = getCountryTimezone;
exports.getDiff = getDiff;
exports.getDuration = getDuration;
exports.getFormat = getFormat;
exports.getIntervalPattern = getIntervalPattern;
exports.getOffsetBase = getOffsetBase;
exports.getOffsetTime = getOffsetTime;
exports.getTimezone = getTimezone;
exports.initBase = initBase;
exports.initCity = initCity;
exports.initTimezone = initTimezone;
exports.timeZone = exports.prettyUnit = void 0;

var _ = require("../");

var C = _interopRequireWildcard(require("./constant"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var cityMap;
var countryTimezone;
var timeZone;
exports.timeZone = timeZone;

var _timezone;

function initBase(config) {
  cityMap = config[0];
  countryTimezone = config[1];
  exports.timeZone = timeZone = config[2];
  return new Promise(function (resolve, reject) {
    return resolve();
  });
}

function initCity(cityId) {
  if (!cityMap[cityId]) throw Error("Elvish Error: cityId is not valid");
  _timezone = cityMap[cityId];
}

function initTimezone(timezone) {
  _timezone = timezone;
}

function getTimezone(cityId) {
  return cityId ? cityMap[cityId] : _timezone;
}

function getBaseInfo() {
  if (!_._locale) {
    throw Error("Elvish Error: please call init function with local parameter first");
  }

  return {
    locale: _._locale
  };
}

function getCountryTimezone(country) {
  return countryTimezone[country];
}

function getDateTime() {
  if (!_._locale) {
    throw Error("Elvish Error: please call init function with local parameter first");
  }

  var dateTime = _._apollo.datetime[_._locale] || _._apollo.datetime["default"];
  if (dateTime.alias) dateTime = _._apollo.datetime[dateTime.alias];
  return dateTime;
}

function getFormat(offsetTime, dateStyle, timeStyle) {
  if (!_._locale) {
    throw Error("Elvish Error: please call init function with local parameter first");
  }

  var map = ['TIME_HH_MM_SS', 'TIME_HH_MM', 'DATE_DD_MM_YYYY', 'DATE_DD_MM_YY', 'DATE_MTH_YYYY', 'DATE_EEE_DD_MTH', 'DATE_DD_MTH', null, 'DATE_NONE', 'TIME_NONE'];
  var dateTimePatterns = getDateTime().dateTimePatterns;

  var getAmPm = function getAmPm() {
    try {
      return new Intl.DateTimeFormat(_._locale, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true
      }).format(offsetTime * 1000).match(/\s\S+$/)[0].replace(/\s/, "");
    } catch (e) {
      return "";
    }
  };

  return {
    dateFormat: dateTimePatterns[map.indexOf(dateStyle)],
    timeFormat: dateTimePatterns[map.indexOf(timeStyle)],
    format: dateTimePatterns[dateTimePatterns.length - 1],
    amPmMarkers: getDateTime().amPmMarkers || getAmPm()
  };
}

function getDuration(seconds) {
  var _getDateTime = getDateTime(),
      duration = _getDateTime.duration;

  if (seconds >= 3600 * 25) {
    if (seconds % (3600 * 24) === 0) {
      return duration[3];
    } else {
      return duration[6];
    }
  }

  ;
  if (seconds >= 3600 * 24 && seconds < 3600 * 25) return duration[3];

  if (seconds >= 3600 + 60) {
    if (seconds % 3600 === 0) {
      return duration[2];
    } else {
      return duration[5];
    }
  }

  if (seconds >= 3600 && seconds < 3600 + 60) return duration[2];

  if (seconds > 60) {
    if (seconds % 60 === 0) {
      return duration[1];
    } else {
      return duration[4];
    }
  }

  ;
  if (seconds == 60) return duration[1];
  return duration[0];
}

function getOffsetBase(timezone, timeStamp) {
  var _timeZone$timezones$t = timeZone.timezones[timezone],
      interval = _timeZone$timezones$t.interval,
      offset = _timeZone$timezones$t.offset,
      mapping = _timeZone$timezones$t.mapping;
  var index;
  interval.forEach(function (one, key) {
    if (timeStamp - timeZone.offset >= one && timeStamp - timeZone.offset < interval[key + 1]) index = key;
  });

  if (index !== undefined) {
    return offset[mapping[index] * 2] + offset[mapping[index] * 2 - 0 + 1];
  }
}

function getOffsetTime(timeStamp, timezone) {
  if (!_._locale) {
    throw Error("Elvish Error: please call init function with local parameter first");
  }

  var _timeZone$timezones = timeZone.timezones[timezone || _timezone],
      interval = _timeZone$timezones.interval,
      offset = _timeZone$timezones.offset,
      mapping = _timeZone$timezones.mapping;
  var index;
  interval.forEach(function (one, key) {
    if (timeStamp - timeZone.offset >= one && timeStamp - timeZone.offset < interval[key + 1]) index = key;
  });
  var offsetTime = timeStamp + offset[mapping[index] * 2] + offset[mapping[index] * 2 - 0 + 1];

  if (index !== undefined) {
    return offsetTime + new Date(offsetTime * 1000).getTimezoneOffset() * 60; // new Date().getTimezoneOffset() * 60 为了抵消掉 下次或者上次调用Date的时候减去的偏移量, Date构造函数会自己算一次偏移量
  } else {
    try {
      //直接使用new Intl.DateTimeFormat().format()的结果， new Date()可能无法解析，因此调整为使用formatToParts
      var formatDateByIntl = new Intl.DateTimeFormat('en-US', {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false,
        timeZone: _timezone
      }).formatToParts(timeStamp * 1000).reduce(function (acc, part) {
        acc[part.type] = part.value;
        return acc;
      }, {});
      var formatDateByIntlResult = "".concat(formatDateByIntl.year, "/").concat(formatDateByIntl.month, "/").concat(formatDateByIntl.day, " ").concat(formatDateByIntl.hour, ":").concat(formatDateByIntl.minute, ":").concat(formatDateByIntl.second);
      return new Date(formatDateByIntlResult).getTime() / 1000;
    } catch (e) {
      // 低端机型不兼容Intl，该逻辑用做Intl的兜底，该返回取的配置中第一个时区偏移可能不准确，潜在bug
      var _offsetTime = timeStamp + offset[mapping[0] * 2] + offset[mapping[0] * 2 - 0 + 1];

      return _offsetTime + new Date(_offsetTime * 1000).getTimezoneOffset() * 60;
    }
  }
} // 填充模板语法


function getIntervalPattern(startTimeStamp, endTimeStamp, dateStyle, timeStyle) {
  var _getDateTime2 = getDateTime(),
      intervalFormats = _getDateTime2.intervalFormats;

  var startDate = new Date(startTimeStamp * 1000);
  var endDate = new Date(endTimeStamp * 1000);
  var type;
  var lrgUnit;

  if (startDate.getFullYear() !== endDate.getFullYear()) {
    lrgUnit = "YEAR";
    if (endDate.getFullYear() - startDate.getFullYear() > 1) throw Error("Elvish Error: Only support across one year");
    if (timeStyle === "TIME_HH_MM") throw Error("Elvish Error: Only the current day is supported when timeStyle is TIME_HH_MM");
  } else if (startDate.getMonth() !== endDate.getMonth()) {
    lrgUnit = "MONTH";
    if (timeStyle === "TIME_HH_MM") throw Error("Elvish Error: Only the current day is supported when timeStyle is TIME_HH_MM");
  } else if (startDate.getDate() !== endDate.getDate()) {
    lrgUnit = "DATE";

    if (dateStyle === "DATE_NONE") {
      dateStyle = "DATE_DD_MM_YYYY";
    }

    if (timeStyle === "TIME_HH_MM") throw Error("Elvish Error: Only the current day is supported when timeStyle is TIME_HH_MM");
  } else if (startDate.getHours() !== endDate.getHours()) {
    lrgUnit = "HOUR";

    if (dateStyle === "DATE_DD_MTH" && timeStyle === "TIME_NONE") {
      dateStyle = "DATE_NONE";
      timeStyle = "TIME_HH_MM";
    }
  } else if (startDate.getMinutes() !== endDate.getMinutes()) {
    lrgUnit = "MINUTE";

    if (dateStyle === "DATE_DD_MTH" && timeStyle === "TIME_NONE") {
      dateStyle = "DATE_NONE";
      timeStyle = "TIME_HH_MM";
    }
  } else {
    lrgUnit = "SECOND";
  }

  if (timeStyle === "TIME_HH_MM") {
    if (dateStyle === "DATE_DD_MM_YYYY") {
      type = "YYYYMMDDHHMM";
    }

    if (dateStyle === "DATE_DD_MTH") {
      type = "MMMDDHHMM";
    }

    if (dateStyle === "DATE_NONE") {
      type = "HHMM";
    }
  } else {
    type = "MMMDD";
  }

  var intervalFormatsArr = intervalFormats[type].map(function (one) {
    return one.dtItvInfos;
  }).reduce(function (a, b) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(b));
  });
  return (intervalFormatsArr.filter(function (one) {
    return one.lrgUnit === lrgUnit;
  })[0] || intervalFormatsArr.filter(function (one) {
    return one.lrgUnit === "*";
  })[0]).intervalPattern;
}

var prettyUnit = function prettyUnit(u) {
  var special = {
    M: C.M,
    y: C.Y,
    w: C.w,
    W: C.W,
    d: C.D,
    D: C.DATE,
    h: C.H,
    m: C.MIN,
    s: C.S,
    ms: C.MS,
    Q: C.Q
  };
  return special[u] || String(u || '').toLowerCase().replace(/s$/, '');
};

exports.prettyUnit = prettyUnit;

function getDiff(diffSecond, unit) {
  var oneMinute = 60;
  var oneHour = 60 * 60;
  var oneDay = 24 * oneHour;

  switch (unit) {
    case 'day':
      return (diffSecond / oneDay).toFixed(2);

    case 'hour':
      return (diffSecond / oneHour).toFixed(2);

    case 'minute':
      return (diffSecond / oneMinute).toFixed(2);

    default:
      return diffSecond;
  }
}

function checkoutTimestamp(timestamp) {
  if (!Number.isInteger(+timestamp)) {
    console.warn("Elvish Warning: timestamp must be Integer");
  }

  if (String(timestamp).length !== 10) {
    console.warn("Elvish Warning: timestamp must be 10 digits");
  }

  if (+timestamp - timeZone.offset < 0) {
    console.warn("Elvish Warning: timestamp must be greater than or equal to ".concat(timeZone.offset));
  }
}